export default "__VITE_ASSET__sv2QbOR8__"